module.exports = __webpack_public_path__ + "img/rep-strength.f3b0dc18.svg";